import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {ChoiseComponent} from '../../../../shared/components/choise/choise.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ApiAnalyticReportGeneralGetRequestParams, GroupService, ReferenceService} from '../../../apiModule1';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {quarters, years} from '../../index-ias/filter-dialog/filter-dialog.component';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';

export function conditionalValidator(relatedControlName: string, compareFn: (value: any) => boolean, validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) {
      return null; // Если parent отсутствует (например, при инициализации)
    }

    const relatedControl = control.parent.get(relatedControlName);

    if (!relatedControl) {
      console.warn(`Control with name "${relatedControlName}" not found`);
      return null;
    }

    // Проверяем, является ли связанный контрол обязательным
    if (compareFn(relatedControl.value)) {
      const res = validator(control);
      console.log('res', res);
      return res; // Применяем валидатор, если контрол required
    }

    return null; // Валидатор не активен
  };
}

@Component({
  selector: 'pas-report-general-filter-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    ChoiseComponent,
    MultiSelect3Component,

  ],
  templateUrl: './report-general-filter-dialog.component.html',
  styleUrls: ['../../index-entity/filter-dialog/filter-dialog.component.scss', './report-general-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportGeneralFilterDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ReportGeneralFilterDialogComponent>);
  referenceService = inject(ReferenceService);
  destroyRef = inject(DestroyRef);
  periods: CriterionPeriod[] = [];
  fb = inject(FormBuilder);
  cdr = inject(ChangeDetectorRef);
  groupService = inject(GroupService)
  data: Record<string, any> = inject(MAT_DIALOG_DATA)

  years = years;
  quarters = quarters;

  form: FormGroup = this.fb.group({
    period: new FormControl<CriterionPeriod | null>(null, [Validators.required]),
    year: new FormControl<(typeof years)[number] | null>(null, [Validators.required]),
    quarter: new FormControl<(typeof quarters)[number] | null>(null, [conditionalValidator('period', (v) => v?.name === 'Квартальная', Validators.required)]),
    organizationGroup: new FormControl<Group[] | null>(null),
  });


  get period() {
    return this.form.get('period')?.value;
  }

  onNoClick() {
    this.dialogRef.close();
  }


  ngOnInit(): void {
    this.referenceService.apiReferencePeriodsGet()
      .pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
        this.periods = v;
        this.setFormData();
        this.cdr.detectChanges();
      })

  }

  setFormData(): void {
    const period = this.data ? this.periods.find(v => v.id === this.data['periodId']) : null;
    this.groupService.apiGroupGet({pageIndex: 0})
      .pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(groups => {
        if(!groups || !groups.length || !this.data) return
        const organizationGroup = this.data['organizationGroupIds'] && this.data['organizationGroupIds']
          .map((v:number) => groups.find((g: Group) => g.id === v))

        const year =  this.data['year'] && years.find(v => v.name == this.data['year'])

        const quarter = this.data['quarter'] && quarters.find(v => v.name == this.data['quarter'])

        this.form.patchValue({
          period,
          year,
          quarter,
          organizationGroup,
        })
      })
  }

  onApply() {
    if (this.form.invalid) return;
    const res: ApiAnalyticReportGeneralGetRequestParams = {
      periodId: this.form.get('period')?.value?.id,
      year: this.form.get('year')?.value?.name,
      quarter: this.form.get('period')?.value?.id === 1 ? undefined : this.form.get('quarter')?.value?.id,
      organizationGroupIds: this.form.get('organizationGroup')?.value?.map((v: Group) => v.id),
    }
    this.dialogRef.close(res)
  }

  onReset() {
    this.form.reset();
  }
}
